import React, { Fragment } from "react";
import { Spin, Modal, Form, Button } from "antd";

import _ from "lodash";
import moment from "moment";
import "moment/locale/fr";
import Typerdv from "./FormItems/Typerdv";
import TimeBeginEnd from "./FormItems/TimeBeginEnd";
import DatePicker from "./FormItems/DatePicker";
import FormSelect, { FormSelectId } from "./FormItems/FormSelect";
// Components
import ConfirmButton from "./../buttons/ConfirmButton";
import CancelButton from "./../buttons/CancelButton";
import AuthRender from "../../../src/containers/AuthRender";
import PrepareButton from "../activite/buttons/PrepareButton";
import { GSK_ID } from "../../configs/constants";
import { PDC_FIELD_NAME, shouldSynchronizePdcField } from "./eventForm.utils";

export default Form.create()(
  class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isLoadingCreationModal: false,
        eventTypeSelected: undefined,
        eventSubtypeSelected: undefined
      };
    }

    componentDidMount() {
      // this.props.updateFilters("type", "physique");
    }

    componentDidUpdate(prevProps) {
      const { requestResponse, visitType, selectedType, isToBeModified } = this.props;

      if (shouldSynchronizePdcField(prevProps, this.props)) {
        this.props.form.setFieldsValue({
          [PDC_FIELD_NAME]: this.props.selectedPdcId || null
        });
      }

      if (
        !this.props.selectedPdcId &&
        this.props.selectedPdc &&
        this.props.userPdcs &&
        (prevProps.selectedPdc !== this.props.selectedPdc || prevProps.userPdcs !== this.props.userPdcs)
      ) {
        const pdcMatch = this.props.userPdcs.find(function(p) { return p.pdc_label === this.props.selectedPdc; }, this);
        if (pdcMatch) this.handleSelectChangePdcId(pdcMatch.pdc_id);
      }

      if (prevProps.requestResponse !== requestResponse) {
        if (!_.isEmpty(requestResponse)) {
          if (requestResponse.status === 1) {
            this.props.changeVisibleCreationModal();
            this.props.form.resetFields();
          }
          this.props.requestResponseModal(requestResponse);
        }
      }
      if (prevProps.isToBeModified && !isToBeModified) this.handleResetState();
      if (prevProps.visitType !== visitType) this.setState({ eventSubtypeSelected: visitType });
      if (!this.state.eventTypeSelected && selectedType && this.props.eventTypes)
        this.setState({
          eventTypeSelected: selectedType,
          eventSubtypesOptions: this.props.eventTypes
            .filter(item => item.type_fr === selectedType)
            .map(item => item.sous_type_fr)
        });
    }

    handleResetState = () => {
      this.setState({
        eventTypeSelected: undefined,
        eventSubtypeSelected: undefined
      });
    };

    handleCreationModalCancel = () => {
      this.props.changeVisibleCreationModal();
      this.handleResetState();
      this.props.form.resetFields();
    };
    handleSelectChangeUserEmail = value => {
      this.props.updateFilters("email", value);
    };
    handleSelectChangeSector = value => {
      this.props.updateFilters("sector_label", value);
    };
    handleSelectChangePdcId = value => {
      this.props.setSelectedPdcId(value);
      this.props.updateFilters("pdc_id", value);
    };

    handleSelectChangeEventSubtype = value => {
      this.props.updateFilters("type", value);
      this.setState({ eventSubtypeSelected: value });
    };

    handleSelectChangeEventType = value => {
      const event_sous_type_fr = value.split(" - ")[1];
      this.props.updateFilters("type", event_sous_type_fr);
      this.setState({ eventSubtypeSelected: event_sous_type_fr });
    };

    handleCreationModalOk = () => {
      const { eventInfos, currentClient } = this.props;
      let event = {
        start_date: this.props.form
          .getFieldValue("date")
          .set({
            hour: this.props.form.getFieldValue("startTime").get("hour"),
            minute: this.props.form.getFieldValue("startTime").get("minute")
          })
          .format(),
        end_date: this.props.form
          .getFieldValue("date")
          .set({
            hour: this.props.form.getFieldValue("endTime").get("hour"),
            minute: this.props.form.getFieldValue("endTime").get("minute")
          })
          .format(),
        rdv: this.props.form.getFieldValue("rdv")
      };
      if (this.props.isToBeModified) {
        this.props.sendUpdatedEvent(
          {
            client_id: currentClient.id,
            sector_id: eventInfos.sector_id,
            pdc_id: eventInfos.pdc_id,
            user_id: eventInfos.user_id,
            end_date: event.end_date,
            start_date: event.start_date,
            event_type_id: eventInfos.event_type_id,
            rdv: event.rdv,
            _id: eventInfos._id
          },
          "click"
        );
      } else {
        if (
          this.props.selectedEmail &&
          this.props.selectedSector &&
          this.props.selectedPdcId &&
          this.props.visitType &&
          event.start_date < event.end_date
        ) {
          this.props.sendNewEvent(event);
        } else {
          const errorText =
            event.start_date >= event.end_date
              ? "Veuillez sélectionner une heure de fin supérieure à l'heure du début de votre événement."
              : "Veuillez renseigner tous les champs.";

          Modal.error({
            title: "",
            content: errorText
          });
          return;
        }
      }
    };

    handleConfirmDelete = () => {
      Modal.confirm({
        title: "Etes-vous sûr de vouloir supprimer cet événement ?",
        content: "",
        okText: "Oui",
        okType: "danger",
        cancelText: "Non",
        onOk: () => {
          this.handleResetState();
          this.props.deleteEvent(this.props.eventInfos);
        },
        onCancel() {}
      });
    };

    render() {
      const { isToBeModified, eventInfos = {}, currentClient = {}, selectedType, visitType } = this.props;
      const { getFieldDecorator } = this.props.form;
      const formItemLayout = {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      };

      const userPdcs =
        currentClient.id === GSK_ID ? this.props.userPdcs.filter(p => p.statut !== "potentiel") : this.props.userPdcs;

      const pdcFromLabel = this.props.selectedPdc && userPdcs.find(p => p.pdc_label === this.props.selectedPdc);
      const pdcDefaultValue = this.props.selectedPdcId || (pdcFromLabel && pdcFromLabel.pdc_id);

      const getEventTypesOptions = () => {
        if (this.props.eventTypes) {
          return this.props.eventTypes.reduce((acc, item) => {
            acc.push(item.type_fr + " - " + item.sous_type_fr);
            return acc;
          }, []);
        } else return [];
      };
      const visitTypeDefaultValue = selectedType ? `${selectedType} - ${visitType}` : undefined;
      return (
        <Fragment>
          <Modal
            visible={this.props.visibleCreationModal}
            title={this.props.isToBeModified ? "Modifier un événement" : "Planifier un événement"}
            onOk={this.handleCreationModalOk.bind(this)}
            onCancel={this.handleCreationModalCancel}
            footer={[
              ((isToBeModified && moment().isBefore(eventInfos.end_date)) || !isToBeModified) && (
                <ConfirmButton
                  label={this.props.isToBeModified ? "Modifier" : "Créer"}
                  large={true}
                  onClick={this.handleCreationModalOk}
                />
              ),
              isToBeModified && moment().isBefore(eventInfos.end_date) && (
                <ConfirmButton
                  label="Supprimer"
                  large={true}
                  onClick={this.handleConfirmDelete}
                  classes={"p-mrg-left-s p-btn-red p-mrg-right-l"}
                />
              ),
              <CancelButton
                label="Annuler"
                large={true}
                onClick={this.handleCreationModalCancel}
                classes={this.props.isToBeModified ? "p-mrg-left-s p-mrg-right-s" : "p-mrg-left-s"}
              />,
              this.props.hasVisitPreparation ? (
                <PrepareButton label="Préparer" large={true} pdcId={this.props.selectedPdcId} />
              ) : null
            ]}
          >
            <Spin
              spinning={this.state.isLoadingCreationModal || this.props.modalIsLoading}
              tip="Chargement des données utilisateur..."
            >
              <Form
                ref={formRef => {
                  this.formRef = formRef;
                }}
                layout="vertical"
              >
                <AuthRender minRole={3}>
                  <FormSelect
                    disabled={isToBeModified}
                    formItemLayout={formItemLayout}
                    getFieldDecorator={getFieldDecorator}
                    placeholder="Choisir un utilisateur"
                    handleSelectChange={this.handleSelectChangeUserEmail}
                    setKeyFilterSelected={this.props.setKeyFilterSelected}
                    defaultValue={this.props.selectedEmail}
                    label="email"
                    itemsSelect={this.props.usersList}
                    item="Utilisateur"
                  />
                </AuthRender>
                <DatePicker
                  {...this.props}
                  availableDates={this.props.availableDates}
                  formItemLayout={formItemLayout}
                  getFieldDecorator={getFieldDecorator}
                  getAvailableDateRange={this.props.getAvailableDateRange}
                  disabled={isToBeModified && moment().isAfter(eventInfos.end_date)}
                />
                <FormSelect
                  disabled={isToBeModified}
                  formItemLayout={formItemLayout}
                  getFieldDecorator={getFieldDecorator}
                  placeholder="Choisir un secteur"
                  handleSelectChange={this.handleSelectChangeSector}
                  setKeyFilterSelected={() => {
                    this.props.form.getFieldValue("date") &&
                      this.props.setKeySectorFilterSelected(this.props.form.getFieldValue("date").format());
                  }}
                  defaultValue={this.props.selectedSector}
                  label="sector_label"
                  itemsSelect={this.props.userSectorsList}
                  item="Secteur"
                />
                {!this.props.selectedSector ? null : (
                  <FormSelectId
                    disabled={isToBeModified}
                    formItemLayout={formItemLayout}
                    getFieldDecorator={getFieldDecorator}
                    placeholder="Choisir un point de contact"
                    handleSelectChange={this.handleSelectChangePdcId}
                    setKeyFilterSelected={() => {
                      this.props.form.getFieldValue("date") &&
                        this.props.setKeyPdcFilterSelected(this.props.form.getFieldValue("date").format());
                    }}
                    defaultValue={pdcDefaultValue}
                    label="pdc_label"
                    keyId="pdc_id"
                    itemsSelect={userPdcs}
                    item={PDC_FIELD_NAME}
                    originalLabel={eventInfos.pdc_label}
                    clientId={currentClient.id}
                  />
                )}
                <TimeBeginEnd
                  currentHour={this.props.form.getFieldValue("startTime")}
                  currentDate={this.props.form.getFieldValue("date") ? this.props.form.getFieldValue("date") : ""}
                  {...this.props}
                  formItemLayout={formItemLayout}
                  getFieldDecorator={getFieldDecorator}
                  disabled={isToBeModified && moment().isAfter(eventInfos.end_date)}
                />
                <FormSelect
                  formItemLayout={formItemLayout}
                  getFieldDecorator={getFieldDecorator}
                  placeholder="Type d'évènement"
                  defaultValue={visitTypeDefaultValue}
                  setKeyFilterSelected={this.props.setKeyFilterSelected}
                  handleSelectChange={this.handleSelectChangeEventType}
                  label="event_type"
                  itemsSelect={getEventTypesOptions()}
                  item="Type d'évènement"
                  disabled={isToBeModified && moment().isAfter(eventInfos.end_date)}
                  disabledOnFocusFunction={true}
                />

                <Typerdv
                  {...this.props}
                  formItemLayout={formItemLayout}
                  getFieldDecorator={getFieldDecorator}
                  defaultValue={this.props.rdv}
                  disabled={isToBeModified && moment().isAfter(eventInfos.end_date)}
                />
              </Form>
            </Spin>
            {eventInfos.contact_name && (
              <div className={"my-2"}>{`Contact du rendez-vous : ${eventInfos.contact_name} ${
                eventInfos.contact_role ? ` ( rôle : ${eventInfos.contact_role})` : ""
              }`}</div>
            )}
            {eventInfos.visit_id && (
              <Button
                type={"primary"}
                className="cursor-pointer bg-green-400 text-white mx-2 px-2 py-2"
                onClick={() => window.open(`${window.location.origin}/visit/preview/${eventInfos.visit_id}`, "_blank")}
              >
                Aller vers la visite
              </Button>
            )}
          </Modal>
        </Fragment>
      );
    }
  }
);



// WEBPACK FOOTER //
// src/components/planning/EventForm.js